import { Button } from "@components/ui/button"
import { AtSign, Loader2 } from "lucide-react"
import { useSendEmailCorrespondence } from "@apis/correspondences/useCorrespondences"
import { toast } from "sonner"
import { AxiosError } from "axios"
import { useCorrespondenceResolver } from "./utils/useCorrespondenceResolver"

interface TButtonProps {
  account_correspondence_id: number
  account_id: string
  isWelcome: boolean
}

export const SendEmailButton = ({
  account_correspondence_id,
  account_id,
  isWelcome,
}: TButtonProps) => {
  const { getCorrespondenceId, isCorrespondenceResolverFetching } =
    useCorrespondenceResolver({
      account_id,
      account_correspondence_id,
      isWelcome,
    })
  const sendEmailCorrespondenceMutation = useSendEmailCorrespondence()

  const handleClick = async () => {
    const correspondenceId = await getCorrespondenceId()
    if (!correspondenceId) {
      toast.error("Error fetching welcome kit")
      return
    }

    sendEmailCorrespondenceMutation.mutate(
      {
        account_correspondence_id: correspondenceId,
      },
      {
        onSuccess: () => {
          toast.success("Email successfully Sent!")
        },
        onError: (error: string | AxiosError) =>
          toast.error(`Error sending email! ${error}`),
      },
    )
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={handleClick}
      disabled={
        (!account_correspondence_id && !isWelcome) ||
        sendEmailCorrespondenceMutation.isPending ||
        isCorrespondenceResolverFetching
      }
    >
      {sendEmailCorrespondenceMutation.isPending ? (
        <Loader2 className="tw:animate-spin" />
      ) : (
        <AtSign />
      )}
    </Button>
  )
}
